// extracted by mini-css-extract-plugin
export var bodySections = "_ak-8";
export var gray = "_ak-7";
export var green = "_ak-4";
export var iconContainer = "_ak-9";
export var iconWidgetContainer = "_ak-1";
export var phoneIcon = "_ak-2";
export var red = "_ak-5";
export var statusDot = "_ak-3";
export var widgetContainer = "_ak-0";
export var yellow = "_ak-6";